module.exports = __webpack_public_path__ + "static/img/content.8454480.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/content.png
// module id = T8UY
// module chunks = 1